export const aciDirection = {
    iconName: 'direction',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 21 21' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M9.388 5.922a.69.69 0 00-.22-.95c-.93-.58-2.12-.916-3.399-.916H1.501a.69.69 0 100 1.38H5.77c1.046 0 1.979.276 2.669.706a.69.69 0 00.95-.22z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M4.393 8.507a.69.69 0 00.057-.974L1.612 4.341 4.45 1.148A.69.69 0 003.42.232L.173 3.882a.69.69 0 000 .917l3.245 3.65a.69.69 0 00.974.058zM9.614 20.85a.69.69 0 00.69-.69V9.723c0-2.36 1.941-4.287 4.358-4.287h4.687a.69.69 0 000-1.38h-4.687c-3.16 0-5.738 2.528-5.738 5.667V20.16c0 .381.31.69.69.69z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M16.457 8.507a.69.69 0 00.974-.058l3.245-3.65a.69.69 0 000-.916L17.43.232a.69.69 0 10-1.031.916l2.838 3.193L16.4 7.533a.69.69 0 00.057.974z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
